export default "__VITE_ASSET__DT3DdW2$__"